import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppShell from "@/components/layout/AppShell";
import HowCalculated from "@/components/HowCalculated";
import Overview from "@/pages/Overview";
import StreamPage from "@/pages/StreamPage";
import Applications from "@/pages/Applications";
import ScenarioComparison from "@/pages/ScenarioComparison";
import DependenciesPage from "@/pages/DependenciesPage";
import ReportsPage from "@/pages/ReportsPage";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import Stub from "@/pages/Stub";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/store/AuthContext";
import { Loader2 } from "lucide-react";

function Gate() {
  const { user, checking } = useAuth();
  if (checking || user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: "#0F2043" }}>
        <Loader2 className="animate-spin text-white/70" size={28} />
      </div>
    );
  }
  if (!user) return <Login />;
  return (
    <>
      <AppShell>
        <Routes>
          <Route path="/" element={<Overview />} />
          <Route path="/subscriber" element={<StreamPage stream="SUBSCRIBER" />} />
          <Route path="/technician" element={<StreamPage stream="TECHNICIAN" />} />
          <Route path="/executive" element={<StreamPage stream="EXECUTIVE" />} />
          <Route path="/shared" element={<StreamPage stream="SHARED" />} />
          <Route path="/applications" element={<Applications />} />
          <Route path="/scenarios" element={<ScenarioComparison />} />
          <Route path="/testing" element={<Stub />} />
          <Route path="/dependencies" element={<DependenciesPage />} />
          <Route path="/issues" element={<Stub />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </AppShell>
      <HowCalculated />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Gate />
        <Toaster />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
